module.exports = __webpack_public_path__ + "static/img/feature-bg.4a82bb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature-bg.png
// module id = Xhqm
// module chunks = 0